module.exports = __webpack_public_path__ + "static/media/ne.fe232d8a.svg";